import logo from "../assets/images/logo.webp";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import _CONFIG_ from "config/Constant";
import { useState } from "react";

export default function Header() {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu);
  };
  return (
    <header>
      <div className="container">
        <div className="row no-gutter">
          {isMobile ? (
            <>
              <div
                className="col-1"
                onClick={() => {
                  handleToggleMenu();
                }}
              >
                {toggleMenu ? "✖" : "☰"}
              </div>
              <div className="col-9 flex justify-center">
                <div id="logo-block">
                  <Link to="/">
                    <img src={logo} height={48} alt="Heng Ong Bet" />
                  </Link>
                </div>
              </div>
              <div className="col-2">&nbsp;</div>
              {toggleMenu && (
                <div className="header-menu header-menu-mob">
                  <ul className="flex g-5 flex-dir-col">
                    <li>
                      <Link
                        to="/slots"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Slots
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/live-casino"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Live Casino
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sports"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Sports
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/lottery"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Lottery
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/download"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Download
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/promotions"
                        onClick={() => {
                          handleToggleMenu();
                        }}
                      >
                        Promotions
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="col-3">
                <div id="logo-block">
                  <Link to="/">
                    <img src={logo} height={48} alt="Heng Ong Bet" />
                  </Link>
                </div>
              </div>
              <div className="flex col-9 justify-end align-center">
                <div className="header-menu">
                  <ul className="flex g-20">
                    <li>
                      <Link to="/slots">Slots</Link>
                    </li>
                    <li>
                      <Link to="/live-casino">Live Casino</Link>
                    </li>
                    <li>
                      <Link to="/sports">Sports</Link>
                    </li>
                    <li>
                      <Link to="/lottery">Lottery</Link>
                    </li>
                    <li>
                      <Link to="/download">Download</Link>
                    </li>
                    <li>
                      <Link to="/promotions">Promotions</Link>
                    </li>
                  </ul>
                </div>
                <div className="header-btns">
                  <a
                    href={_CONFIG_.REGISER_URL}
                    className="btn-primary"
                    rel="noopener nofollow"
                  >
                    Login
                  </a>
                  <a
                    href={_CONFIG_.REGISER_URL}
                    className="btn-secondary"
                    rel="noopener nofollow"
                  >
                    Register
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
